// store/modules/preload.js
import preloadConfig from '../preloadConfig'

const state = {}
const mutations = {}
const actions = {}
const getters = {}

// 自动生成state/mutations/actions/getters
Object.keys(preloadConfig).forEach(key => {
    // 1. 初始化state
    state[key] = []

    // 2. 自动创建mutation (setXxx)
    const mutationName = `set${key.charAt(0).toUpperCase() + key.slice(1)}`
    mutations[mutationName] = (state, payload) => {
        state[key] = payload
    }

    // 3. 自动创建action (fetchXxx)
    const actionName = `fetch${key.charAt(0).toUpperCase() + key.slice(1)}`
    actions[actionName] = async ({ commit }) => {
        try {
            const res = await preloadConfig[key].api()
            if (res.code !== 200) {
                console.warn(`接口 ${key} 返回非200状态码: ${res.code}`)
                commit(mutationName, [])
                return []
            }
            const data = res.data.map(preloadConfig[key].formatter)
            commit(mutationName, data)
            return data
        } catch (error) {
            console.error(`预加载 ${key} 失败:`, error)
            commit(mutationName, [])
            return []
        }
    }

    // 4. 自动创建getter
    getters[key] = state => state[key]
})

// 5. 创建批量加载的action
actions.loadAll = async ({ dispatch }) => {
    const requests = Object.keys(preloadConfig).map(key =>
        dispatch(`fetch${key.charAt(0).toUpperCase() + key.slice(1)}`)
    )
    return Promise.all(requests)
}

// 6. 新增：手动更新数据的mutation和action
mutations.updatePreloadData = (state, { key, data }) => {
    if (state.hasOwnProperty(key)) {
        state[key] = data
    }
}

actions.updatePreloadData = ({ commit }, { key, data }) => {
    commit('updatePreloadData', { key, data })
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}